import axios from "axios";
import * as constants from "../Constatnts";



export function getAuditTrails(registrationID, collectionName, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/audittrails/${collectionName}/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.auditTrails;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

